namespace RioERP.Administration {
    export interface UserRoleListResponse extends Serenity.ListResponse<number> {
    }
}

